<div class="dialog confirmModal" id="{{modalID}}" [dir]="textDir">
    <div class="content">
      <div class="top marB5" [dir]="textDir">
        <div class="left"> 
          <div *ngIf="modalID!='deleteConfirmModal'">
            <img src="assets/images/error3x.png" width="29" height="30" align="middle">
          </div>
          <div *ngIf="modalID=='deleteConfirmModal'">
            <img src="assets/images/delete2x.png" width="29" height="30" align="middle">
          </div>
          <!-- <div *ngIf="modalID == 'groupDeleteConifrmModal' || modalID=='deleteConfirmModal'">
            <img src="assets/images/delete2x.png" width="29" height="30" align="middle">

          </div> -->
          <div class="title marT5" style="width: 240px;" [ngClass]="textDir=='rtl'?'marR15':'marL15'">{{this.titleMessage | translate}}</div>             
        </div>
      </div>
      <div class="body" [ngClass]="textDir=='ltr'?'marR20':''" [dir]="textDir">
        
        <div *ngIf="this.subTitleMessage" > {{this.subTitleMessage | translate}}</div> 
        
        <div *ngIf="this.listMessage"> 
          <ul class="marT15">
            <li class="no-pad" *ngFor="let item of this.listMessage">
              {{item.name | translate}}
            </li>
          </ul>
        </div> 
        <div *ngIf="this.listMessage1"> 
          <ul class="marT15">
            <li class="no-pad" *ngFor="let item of this.listMessage1">
              {{item.name | translate}}
            </li>
          </ul>
        </div> 
        <div *ngIf="this.detailMessage" class="padT15"> {{this.detailMessage | translate}}</div> 
        <div *ngIf="this.detailMessageLine1" class="padT15"> {{this.detailMessageLine1 | translate}}</div> 
      </div>
      <div class="bottom padT15" [dir]="textDir">
        <a class="btn btn-next" data-close="true">&nbsp;&nbsp;{{'Cancel' | translate}}&nbsp;&nbsp;</a>
        <a *ngIf="this.detailMessageLine1 !== 'Select OK to confirm.'" class="btn primary" (click)='confirmed()'>&nbsp;&nbsp;{{'Confirm' | translate}}&nbsp;&nbsp;</a>
        <a *ngIf="this.detailMessageLine1 == 'Select OK to confirm.'" class="btn primary" (click)='confirmed()'>&nbsp;&nbsp;{{'Ok' | translate}}&nbsp;&nbsp;</a>
      </div>
    </div>
</div>